const rootEl = document.documentElement;

let openModal = null;
let lastTrigger = null;

function show(modal, trigger) {
  // The embed is parked in a <template> so nothing loads until now. Clone it
  // in on first open; later opens reuse what is already there so the video
  // does not restart from scratch every time.
  const target = modal.querySelector('.js-featured-modal-target');
  const source = modal.querySelector('.js-featured-modal-embed');
  if (target && source && !target.hasChildNodes()) {
    target.appendChild(source.content.cloneNode(true));
  }

  modal.classList.add('modal-is-active');
  rootEl.classList.add('modal-is-active');

  openModal = modal;
  lastTrigger = trigger || null;

  const close = modal.querySelector('.js-close-featured-modal');
  if (close) {
    close.focus();
  }
}

function hide() {
  if (!openModal) {
    return;
  }

  openModal.classList.remove('modal-is-active');
  rootEl.classList.remove('modal-is-active');

  // Emptying the container stops playback. Without this a closed modal keeps
  // its video or podcast running, audible, with no visible control to stop it.
  const target = openModal.querySelector('.js-featured-modal-target');
  if (target) {
    target.innerHTML = '';
  }

  openModal = null;

  if (lastTrigger) {
    lastTrigger.focus();
    lastTrigger = null;
  }
}

function onTriggerClick(e) {
  e.preventDefault();
  const modal = document.querySelector(e.currentTarget.getAttribute('href'));
  if (modal) {
    show(modal, e.currentTarget);
  }
}

// Only the modal itself, not anything inside it — a click that lands on the
// player must not count as a click on the backdrop.
function onBackdropClick(e) {
  if (e.target === e.currentTarget) {
    hide();
  }
}

function onKeydown(e) {
  if (!openModal) {
    return;
  }

  if (e.key === 'Escape') {
    hide();
    return;
  }

  // Two focusable things exist while a modal is open — its close button and
  // whatever the browser hands focus to inside the iframe — so the trap is a
  // wrap back to the close button rather than a list of stops.
  if (e.key === 'Tab' && !openModal.contains(document.activeElement)) {
    e.preventDefault();
    const close = openModal.querySelector('.js-close-featured-modal');
    if (close) {
      close.focus();
    }
  }
}

export default function() {
  document.querySelectorAll('.js-show-featured-modal').forEach(el => {
    el.addEventListener('click', onTriggerClick);
  });

  document.querySelectorAll('.js-featured-modal').forEach(el => {
    el.addEventListener('click', onBackdropClick);
  });

  document.querySelectorAll('.js-close-featured-modal').forEach(el => {
    el.addEventListener('click', hide);
  });

  document.addEventListener('keydown', onKeydown);
}
